module.exports = "/assets/gift-events-listing/BW24-banner-desktop.png?P6qT41A";